/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserResponseAdminAdminDto } from '../../models/user-response-admin-admin-dto';

export interface AdminUsersControllerGetAdminUserById$Params {
  id: string;
}

export function adminUsersControllerGetAdminUserById(http: HttpClient, rootUrl: string, params: AdminUsersControllerGetAdminUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponseAdminAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminUsersControllerGetAdminUserById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserResponseAdminAdminDto>;
    })
  );
}

adminUsersControllerGetAdminUserById.PATH = '/admin/users/{id}';
